<template>
  <div>
    <SelectDateBetween
      v-if="displaySelectFull && !isBirthdate"
      :name="name"
      :type_list="type_list"
      :search="search"
      :label="label"
      :validation="validation"
      :defaultSelected="filters"
      :placeholder="placeholder"
      @add-data="$emit('addData', $event)"
      @data-selected="getFilters($event)"
      @close="displaySelectFull = false"
    />

    <SelectBirthdate
      v-if="displaySelectFull && isBirthdate"
      :name="name"
      :type_list="type_list"
      :search="search"
      :label="label"
      :validation="validation"
      :defaultSelected="filters"
      :placeholder="placeholder"
      @add-data="$emit('addData', $event)"
      @data-selected="getFilters($event)"
      @close="displaySelectFull = false"
    />

    <div
      v-if="!displaySelectFull"
      style="text-align: left"
      class="full-screen bordered-bottom"
    >
      <label
        class="label"
        @click="displaySelectFull = true"
      >{{ label }}</label>
      <div class="main-form">
        <div
          class="segments"
          @click="displaySelectFull = true"
        >
          <div
            v-if="filters != null && filters['value1']"
            class="segment"
          >
            <span>{{ moment(filters['value1']).locale($i18n.locale).format('L') }} -
              {{ moment(filters['value2']).locale($i18n.locale).format('L') }}
            </span>
          </div>
          <div
            v-else-if="filters != null"
            class="segment"
          >
            <span>{{ $t(`form.${filters}`) }}</span>
          </div>
        </div>
        <div
          v-if="filters != null"
          class="delete-values"
          @click="[(filters = null), storeData()]"
        >
          <img
            src="@/assets/icons/close.png"
            alt="close"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectDateBetween from '@/components/GenericComponents/Form/SelectDateBetween.vue'
import SelectBirthdate from '@/components/GenericComponents/Form/SelectBirthdate.vue'
import moment from 'moment'

export default {
  name: 'BetweenDateFullScreen',
  components: { SelectDateBetween, SelectBirthdate },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    validation: {
      type: [String, Boolean],
      default: null
    },
    type_list: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [Object, Array],
      default: null
    },
    isBirthdate: {
      type: Boolean,
      defaut: false
    }
  },
  emits: ['addData'],
  data() {
    return {
      displaySelectFull: false,
      filters: null,
      moment
    }
  },
  mounted() {
    if (this.defaultValue) {
      if (Array.isArray(this.defaultValue)) {
        this.filters = this.defaultValue[0].value
      } else {
        this.filters = this.defaultValue
      }
      this.storeData()
    }
  },
  methods: {
    getFilters(e) {
      this.filters = e
      this.storeData()
    },
    formatData(label, value, extra = null) {
      return [{ label, value, extra }]
    },
    storeData() {
      this.$emit('addData', {
        value: this.filters ? this.formatData(this.label, this.filters, this.type_list) : null,
        name: this.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .full-screen {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 10px 0;

    .label {
      padding-left: 12px;
      color: #777;
      font-size: 0.75rem !important;
      text-align: left;
    }

    .main-form {
      display: flex;
      padding-left: 12px;

      .segments {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;

        .segment {
          font-size: 0.8rem !important;

          > span {
            margin-right: 5px;
          }
        }
      }
    }

    .delete-values {
      padding: 5px;
      place-self: center center;

      > img {
        height: 1rem;
      }
    }
  }
</style>
